__turbopack_context__.v({
  "backdrop": "CartDrawer-module__houXWW__backdrop",
  "closeButton": "CartDrawer-module__houXWW__closeButton",
  "content": "CartDrawer-module__houXWW__content",
  "drawer": "CartDrawer-module__houXWW__drawer",
  "empty": "CartDrawer-module__houXWW__empty",
  "footer": "CartDrawer-module__houXWW__footer",
  "header": "CartDrawer-module__houXWW__header",
  "headerTitle": "CartDrawer-module__houXWW__headerTitle",
  "item": "CartDrawer-module__houXWW__item",
  "itemActions": "CartDrawer-module__houXWW__itemActions",
  "itemCount": "CartDrawer-module__houXWW__itemCount",
  "itemDetails": "CartDrawer-module__houXWW__itemDetails",
  "itemImage": "CartDrawer-module__houXWW__itemImage",
  "itemName": "CartDrawer-module__houXWW__itemName",
  "itemPrice": "CartDrawer-module__houXWW__itemPrice",
  "itemTotal": "CartDrawer-module__houXWW__itemTotal",
  "items": "CartDrawer-module__houXWW__items",
  "quantityControls": "CartDrawer-module__houXWW__quantityControls",
  "removeButton": "CartDrawer-module__houXWW__removeButton",
  "shippingNote": "CartDrawer-module__houXWW__shippingNote",
  "subtotal": "CartDrawer-module__houXWW__subtotal",
  "subtotalAmount": "CartDrawer-module__houXWW__subtotalAmount",
});
